require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-matteo-iannello-architettura-e-pedagogia-nel-cantone-ticino-tre-casi-studio-mendrisio-2-novembre-2020.json") })
        }
      }, "path---relazioni-e-conferenze-matteo-iannello-architettura-e-pedagogia-nel-cantone-ticino-tre-casi-studio-mendrisio-2-novembre-2020");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-matteo-iannello-architettura-e-pedagogia-nel-cantone-ticino-tre-casi-studio-mendrisio-2-novembre-2020!./.cache/json/relazioni-e-conferenze-matteo-iannello-architettura-e-pedagogia-nel-cantone-ticino-tre-casi-studio-mendrisio-2-novembre-2020.json
// module id = 702
// module chunks = 231608221292675